import React, {Fragment} from 'react';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import Tabs from 'react-responsive-tabs';
import MiniJuegos from './component/MiniJuegos';



const tabsContent = [
    {
        title: 'Mini Juegos',
        content: <MiniJuegos/>
    }
];



function getTabs() {
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}

export default class MiniJuegosComponent extends React.Component {

    render() {

        return (
            <Fragment>
                <PageTitle
                    heading="Objetivos: Mini Juegos"
                    subheading=""
                    icon="lnr-graduation-hat icon-gradient bg-mean-fruit"
                />
                <Tabs tabsWrapperClass="body-tabs body-tabs-layout" transform={false} showInkBar={true} items={getTabs()}/>
               
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/Mini/index.js